module.exports = __webpack_public_path__ + "static/media/1C70124E3B71B787.6842f73f.png";